import React from 'react'
import '../../../../App.scss';
import Grid from "@material-ui/core/Grid";
import silverCoin from "../../../../assets/images/ic_silver_coin.png";
import goldCoin from "../../../../assets/images/ic_coin.png";
import ArrowSpinner from "../../../../assets/images/arrow_spinner_vip.png";
import Light1 from "../../../../assets/images/lucky_light.png";
import Light2 from "../../../../assets/images/lucky_light2.png";

import axios from "axios";
import {rollList, userData} from "../../../../Utility/Url";
import PicoLoader from "../../Common/PicoLoader";
import {login} from "../../../../Store/Actions/AuthActions";

class Spinner extends React.Component{
    constructor(props) {
        super(props)
        this.myRef = React.createRef();
        this.state={
            spinnerData:null,
            light:Light1,
        }
    }

    componentDidMount() {
        setInterval(()=>{
            if (this.state.light===Light1)
                this.setState({
                    light:Light2
                })
            else
                this.setState({
                    light:Light1
                })
        },1000)
    }
    // shouldComponentUpdate(nextProps, nextState, nextContext) {
        // const {firstItems,secondItems}=this.props
        // if (firstItems.length!==0 && secondItems.length!==0 ){
        //     console.log('should update',this.props)
        //     return true
        // }
        // return false
    // }

    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //     return false
    // }
    render() {
        let {degree}=this.props.data
        // alert(degree)
        const {spinnerBackground,cursorImage,cursorHolderImage,stand}=this.props.images
        const {firstItems,secondItems}=this.props
        const transitionEnd=(()=>{
            const actualDeg=degree/360
          this.myRef.current.style.transition='none'
          this.myRef.current.style.transform=`rotate(0deg)`
            setTimeout(()=>{
                this.myRef.current.style.transition='all ease 5s'
            },50)
        })
        return (
            <Grid container style={{height:'100%',position:'relative'}} sm={12} xs={12} justify={"center"} alignItems={"center"}>
                        <img src={stand} style={{position:'absolute',zIndex:'1',top:'80%',width:'50%'}} alt=""/>
                        <Grid style={{
                            backgroundImage: "url(" + spinnerBackground + "),url(" + Light1 + ")",
                            backgroundSize:'contain',
                            backgroundPosition:'center',
                            backgroundRepeat: 'no-repeat',
                            width:'500px',
                            height:'450px',
                            maxWidth:'100vw',
                            maxHeight:'100vw',
                            position:'relative',
                            zIndex:'3',
                            transition:'all ease 5s'
                        }}
                              container justify={"center"}>
                            <img src={this.state.light} style={{position:'absolute',width:'100%',left:'0',top:'0',right:'0',bottom:'0',height:'100%'}} alt=""/>

                            <Grid onTransitionEnd={transitionEnd} item container ref={this.myRef} justify={"center"} alignItems={"center"} style={{
                                position:'absolute',
                                width:'25%',
                                top:'50%',
                                left:'50%',
                                marginTop:'-12.5%',
                                marginLeft:'-12.5%',
                                transform:`rotate(${degree}deg)`,
                                transition:'all ease 5s'
                            }}>
                                <img src={cursorHolderImage} style={{zIndex:'2',width:'100%'}} alt=""/>
                                <img src={cursorImage} style={{
                                    position:'absolute',
                                    top:'-20%',
                                    width:'100%'
                                }} alt=""/>
                            </Grid>
                            <Grid container justify={"center"} sm={9} xs={9} alignItems={"center"}
                                  style={{backgroundColor:''}}
                                  direction={"row-reverse"}
                            >

                                <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}
                                      style={{
                                          padding:'10px',width:'100%',
                                          alignSelf:'flex-end',
                                          position:'relative',
                                      }}
                                >
                                    <img src={firstItems[1].type==='silver'?silverCoin:goldCoin}
                                         style={{width:'80%'}} alt=""/>
                                    <p style={{position:'absolute'}}>{firstItems[1].text}</p>
                                </Grid>

                                <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}
                                      style={{
                                          padding:'10px',width:'100%',
                                          alignSelf:'',
                                          position:'relative',
                                      }}
                                >
                                    <img src={firstItems[0].type==='silver'?silverCoin:goldCoin} style={{width:'80%'}} alt=""/>
                                    <p style={{position:'absolute'}}>{firstItems[0].text}</p>
                                </Grid>

                                <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}
                                      style={{
                                          padding:'10px',width:'100%',
                                          alignSelf:'',
                                          position:'relative',
                                      }}
                                >
                                    <img src={secondItems[3].type==='silver'?silverCoin:goldCoin} style={{width:'80%'}} alt=""/>
                                    <p style={{position:'absolute'}}>{secondItems[3].text}</p>
                                </Grid>

                                <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}
                                      style={{
                                          padding:'10px',width:'100%',
                                          alignSelf:'flex-end',
                                          position:'relative',
                                      }}
                                >
                                    <img src={secondItems[2].type==='silver'?silverCoin:goldCoin} style={{width:'80%'}} alt=""/>
                                    <p style={{position:'absolute'}}>{secondItems[2].text}</p>
                                </Grid>
                            </Grid>
                            <Grid container justify={"center"} sm={9} xs={9} alignItems={"center"}
                                  style={{backgroundColor:''}}
                                  direction={"row-reverse"}
                            >
                                <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}
                                      style={{
                                          padding:'10px',width:'100%',
                                          alignSelf:'flex-start',
                                          position:'relative',
                                      }}
                                >
                                    <img src={firstItems[2].type==='silver'?silverCoin:goldCoin}
                                         style={{width:'80%'}} alt=""/>
                                    <p style={{position:'absolute'}}>{firstItems[2].text}</p>
                                </Grid>

                                <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}
                                      style={{
                                          padding:'10px',width:'100%',
                                          alignSelf:'',
                                          position:'relative',
                                      }}
                                >
                                    <img src={firstItems[3].type==='silver'?silverCoin:goldCoin} style={{width:'80%'}} alt=""/>
                                    <p style={{position:'absolute'}}>{firstItems[3].text}</p>
                                </Grid>

                                <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}
                                      style={{
                                          padding:'10px',width:'100%',
                                          alignSelf:'',
                                          position:'relative',
                                      }}
                                >
                                    <img src={secondItems[0].type==='silver'?silverCoin:goldCoin} style={{width:'80%'}} alt=""/>
                                    <p style={{position:'absolute'}}>{secondItems[0].text}</p>
                                </Grid>

                                <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}
                                      style={{
                                          padding:'10px',width:'100%',
                                          alignSelf:'flex-start',
                                          position:'relative',
                                      }}
                                >
                                    <img src={secondItems[1].type==='silver'?silverCoin:goldCoin} style={{width:'80%'}} alt=""/>
                                    <p style={{position:'absolute'}}>{secondItems[1].text}</p>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
            // <h1>
            //     dawdaw
            // </h1>
        )
    }
}
export default Spinner